import { Model } from '../api/model-service/model-service';

export function isModelAsSold(model: Model): boolean {
    return model.version === 'AS_SOLD';
}
